import { CampusApplicationProcessState } from '../../CampusApplication/CampusApplicationProcessState';
import { OnlineApplicationProcessState } from '../../OnlineApplication/OnlineApplicationProcessState';

export enum ApplicationProgressState {
    NoApplicationInProgress,
    CampusApplicationInProgress,
    OnlineApplicationInProgress,
}

export const getApplicationProgressState: () => ApplicationProgressState = () => {
    const campusApplicationProcessState = CampusApplicationProcessState();
    const onlineApplicationProcessState = OnlineApplicationProcessState();

    const campusChoices = campusApplicationProcessState.getAll();

    if (campusChoices && campusChoices.length > 0) {
        return ApplicationProgressState.CampusApplicationInProgress;
    }

    const onlineChoices = onlineApplicationProcessState.getAll();

    if (onlineChoices && onlineChoices.length > 0) {
        return ApplicationProgressState.OnlineApplicationInProgress;
    }

    return ApplicationProgressState.NoApplicationInProgress;
};
